<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="typewriter">
    <h1>Welcome to Student Management System..</h1>
  </div>
</div>
